import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    FormGroup,
    InputAdornment,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField
} from '@mui/material';
import { toast } from 'react-toastify';
import styles from "../../assets/styles/appointments.module.css";
import { SearchIcon } from '../../utils/functions/Icons';
import ConfirmModal from '../common/ConfirmModal';
import NoDataFound from '../common/NoDataFound';
import Loader from '../common/Loader';
import { getHealthCheckupsApi, updateLabReportApi } from '../../utils/api/services';
import { useSelector } from 'react-redux';
import { RootState } from '../../utils/store';

export default function Requested() {
    const [searchValue, setSearchValue] = useState('');
    const [year, setYear] = useState<string | number>('0');
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [labTestData, setLabTestData] = useState<PreEmpLabTest[]>([]);
    const [actionValues, setActionValues] = useState<string[]>([]);
    const [particularData, setParticularData] = useState<PreEmpLabTest | null>(null);
    const { LoginData } = useSelector((state: RootState) => state.auth)

    const handleAction = (event: SelectChangeEvent<string>, index: number, item: PreEmpLabTest) => {
        event.stopPropagation();
        const newActionValues = [...actionValues];
        newActionValues[index] = event.target.value;
        setActionValues(newActionValues);

        if (event.target.value !== '0') {
            setParticularData(item);
            setOpenConfirmModal(true);
        }
    };

    const CloseConfirmModal = () => {
        setOpenConfirmModal(false);
    };

    const fetchLabtestApi = async (data: { search: string; status: string; filter: string | number, companyId: number }) => {
        try {
            setLoading(true);
            const result = await getHealthCheckupsApi(data);
            if (result?.success) {
                setLabTestData(result?.labTests);
                setActionValues(new Array(result?.labTests.length).fill('0'));
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (LoginData) {
            if (searchValue) {
                const cleanFunction = setTimeout(() => {
                    fetchLabtestApi({ search: searchValue, status: '3', filter: year, companyId: LoginData?.companyId });
                }, 1000);
                return () => clearTimeout(cleanFunction);
            } else {
                fetchLabtestApi({ search: searchValue, status: '3', filter: year, companyId: LoginData?.companyId });
            }
        }
    }, [searchValue, year]);

    const confirmSubmit = async () => {
        try {
            setBtnLoading(true)
            const _Status = actionValues[particularData ? labTestData.indexOf(particularData) : -1] === "Approve" ? '1' : '4'
            const result = await updateLabReportApi({ id: particularData?.id, companyId: LoginData?.companyId, status: _Status });
            if (result?.success) {
                setBtnLoading(false)
                toast.success(result?.message)
                if (LoginData) {
                    fetchLabtestApi({ search: searchValue, status: '3', filter: year, companyId: LoginData?.companyId });
                }
                CloseConfirmModal();
            }
            else {
                setBtnLoading(false)
                toast.error(result?.message)
            }
        } catch (error: any) {
            setBtnLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }


    return (
        <div>
            <div className="mb-6 flex justify-between items-center flex-col md:flex-row w-full max-w-full gap-y-4 md:gap-y-0">
                <FormGroup className="customFormGroup md:w-1/2 w-full">
                    <TextField
                        className={`custumTextField ${styles.InputStyle}`}
                        id="searchValue"
                        name="searchValue"
                        onChange={(e) => setSearchValue(e.target.value)}
                        value={searchValue}
                        placeholder="Search"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </FormGroup>
                <FormGroup className="customFormGroup md:w-36 w-full">
                    <Select
                        className={`custumTextField profileInput`}
                        placeholder="Date"
                        defaultValue={"0"}
                        value={year}
                        onChange={(e) => setYear(e.target?.value)}
                    >
                        <MenuItem selected value="0">All</MenuItem>
                        <MenuItem value="1">Last Month</MenuItem>
                        <MenuItem value="2">6 Months</MenuItem>
                        <MenuItem value="3">1 Year</MenuItem>
                    </Select>
                </FormGroup>
            </div>
            {
                loading ? <Loader />
                    :
                    <TableContainer component={Paper} className="TableContainer">
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className="custumTableHead">
                                <TableRow className={styles.completeTableRow}>
                                    <TableCell>Patient Name</TableCell>
                                    <TableCell align="right">Gender</TableCell>
                                    <TableCell align="right">Phone</TableCell>
                                    <TableCell align="right">DOB</TableCell>
                                    <TableCell align="right">Check Up Date</TableCell>
                                    <TableCell align="right">Status</TableCell>
                                    <TableCell align="right">Type</TableCell>
                                    <TableCell align="right"></TableCell>
                                </TableRow>
                            </TableHead>
                            {
                                labTestData?.length > 0 ?
                                    <TableBody>
                                        {
                                            labTestData.map((item, index) => {
                                                const bgColor = item?.status === "Scheduled" ? "#80B628" : item?.status === "Completed" ? "#54a276" : item?.status === "Pending" ? "#ffcd29" : item?.status === "Cancelled" ? "#aa2626" : "#FF9800"
                                                const typeColor = item?.type === "pre-enroll" ? "#0562cc" : "#6fc9c6"
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        className="custumTableRow"
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {item.name}
                                                        </TableCell>
                                                        <TableCell align="right">{item.gender}</TableCell>
                                                        <TableCell align="right">{item.phone}</TableCell>
                                                        <TableCell align="right">{item.dateofbirth}</TableCell>
                                                        <TableCell align="right">{item.health_check_up_date}</TableCell>
                                                        <TableCell align="right">
                                                            <div className='flex items-center justify-center'>
                                                                <button className={`outLineBtn ${styles.downloadPresBtn}`} style={{ borderColor: bgColor, color: bgColor }} >{item?.status}</button>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <button className={`outLineBtn ${styles.downloadPresBtn}`} style={{ borderColor: typeColor, color: typeColor }} >{item?.type}</button>
                                                        </TableCell>
                                                        <TableCell >
                                                            <FormGroup className="customFormGroup w-36">
                                                                <Select
                                                                    className={`custumTextField profileInput`}
                                                                    placeholder="Date"
                                                                    defaultValue={"0"}
                                                                    value={actionValues[index] || '0'}
                                                                    onChange={(event) => handleAction(event, index, item)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <MenuItem selected value="0">No Action</MenuItem>
                                                                    <MenuItem value="Approve">Approve</MenuItem>
                                                                    <MenuItem value="Cancel">Cancel</MenuItem>
                                                                </Select>
                                                            </FormGroup>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                    :
                                    <TableBody>
                                        <TableRow className="custumTableRow" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" colSpan={8}>
                                                <NoDataFound />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                            }
                        </Table>
                    </TableContainer>
            }

            <ConfirmModal
                openConfirmModal={openConfirmModal}
                CloseConfirmModal={CloseConfirmModal}
                confirmSubmit={confirmSubmit}
                btnLoading={btnLoading}
                title={`Are you sure you want to ${actionValues[particularData ? labTestData.indexOf(particularData) : -1]} this health checkups?`}
            />
        </div>
    );
}
